__turbopack_context__.v({
  "blink": "Oops-module-scss-module__ZVbsUW__blink",
  "button": "Oops-module-scss-module__ZVbsUW__button",
  "checkout": "Oops-module-scss-module__ZVbsUW__checkout",
  "contentItemText": "Oops-module-scss-module__ZVbsUW__contentItemText",
  "contentSub": "Oops-module-scss-module__ZVbsUW__contentSub",
  "empty": "Oops-module-scss-module__ZVbsUW__empty",
  "footer": "Oops-module-scss-module__ZVbsUW__footer",
  "gridEl": "Oops-module-scss-module__ZVbsUW__gridEl",
  "gridElContinue": "Oops-module-scss-module__ZVbsUW__gridElContinue",
  "header": "Oops-module-scss-module__ZVbsUW__header",
  "item": "Oops-module-scss-module__ZVbsUW__item",
  "itemImage": "Oops-module-scss-module__ZVbsUW__itemImage",
  "links": "Oops-module-scss-module__ZVbsUW__links",
  "oops": "Oops-module-scss-module__ZVbsUW__oops",
  "optionsSelected": "Oops-module-scss-module__ZVbsUW__optionsSelected",
  "quantity": "Oops-module-scss-module__ZVbsUW__quantity",
  "remove": "Oops-module-scss-module__ZVbsUW__remove",
  "subTotal": "Oops-module-scss-module__ZVbsUW__subTotal",
  "title": "Oops-module-scss-module__ZVbsUW__title",
});
